import { useEffect, useRef, useState } from "react";
import { closeLoading, notifyLoading, notifySuccess } from "src/assets/toastService";
import { deleteEmployee, editEmployee, getEmployee, postEmployee } from "src/shared/services/services";
import { ApiResponse, User } from "src/shared/types";
import { errorHandling } from "src/shared/utils/errorHandling";

function useEmployee() {
  const [employee, setEmployee] = useState<User[]>([]);
  const [isLoadingStaff, setIsLoading] = useState<boolean>(false);
  const [fullResponse, setFullResponse] = useState<ApiResponse | null>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  // Fetch employees
  const fetchEmployee = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    setIsLoading(true);

    timerRef.current = setTimeout(() => {
      getEmployee()
        .then((res: any) => {
          const employeeTable: ApiResponse = res.data;
          const employeeData: User[] = res.data.result;

          setFullResponse(employeeTable);
          setEmployee(employeeData);
        })
        .catch((err: any) => {
          errorHandling(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }, 300);
  }

  // Add or update employee
  const saveEmployee = (data: any, closeData: () => void, errorData: () => void) => {
    notifyLoading("Please wait, Employee is being saved...");
    postEmployee(data)
      .then((res: any) => {
        closeLoading();
        notifySuccess("Employee saved successfully");
        fetchEmployee();
        closeData();
      })
      .catch((err: any) => {
        closeLoading();
        errorHandling(err);
        errorData();
      });
  };

  const changeEmployee = (id: any, data: any, closeData: () => void, errorData: () => void) => {
    notifyLoading("Please wait, Employee is being updating...");
    editEmployee(id, data)
      .then((res: any) => {
        closeLoading();
        notifySuccess("Employee updated successfully");
        fetchEmployee();
        closeData();
      })
      .catch((err: any) => {
        closeLoading();
        errorHandling(err);
        errorData();
      });
  };

  const Refetch = () => {
    fetchEmployee();
  };

  const deleteConfirm = (id: any, closeData: () => void) => {
    deleteEmployee(id)
      .then((res: any) => {
        closeLoading();
        notifySuccess("Employee updated successfully");
        fetchEmployee();
        closeData();
      })
      .catch((err: any) => {
        closeLoading();
        errorHandling(err);
      });
  };

  // Fetch on mount
  useEffect(() => {
    fetchEmployee();

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return { employee, fetchEmployee, saveEmployee, changeEmployee, isLoadingStaff, Refetch, deleteConfirm, fullResponse };
}

export default useEmployee;
